/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContentIdea,
  ContentItem,
  ContentItemRequest,
  IdeasQueued,
  IdeasRequestRequest,
  PaginatedContentIdeaList,
  PaginatedContentItemList,
  PatchedContentItemRequest,
  ScheduleRequest,
  StudioContentsCalendarListParams,
  StudioContentsListParams,
  StudioIdeasListParams
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type studioContentsListResponse200 = {
  data: PaginatedContentItemList
  status: 200
}
    
export type studioContentsListResponseSuccess = (studioContentsListResponse200) & {
  headers: Headers;
};
;

export type studioContentsListResponse = (studioContentsListResponseSuccess)

export const getStudioContentsListUrl = (params?: StudioContentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/studio/contents/?${stringifiedParams}` : `/api/v1/studio/contents/`
}

export const studioContentsList = async (params?: StudioContentsListParams, options?: RequestInit): Promise<studioContentsListResponse> => {
  
  return apiFetch<studioContentsListResponse>(getStudioContentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStudioContentsListQueryKey = (params?: StudioContentsListParams,) => {
    return [
    `/api/v1/studio/contents/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStudioContentsListQueryOptions = <TData = Awaited<ReturnType<typeof studioContentsList>>, TError = unknown>(params?: StudioContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStudioContentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof studioContentsList>>> = ({ signal }) => studioContentsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof studioContentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StudioContentsListQueryResult = NonNullable<Awaited<ReturnType<typeof studioContentsList>>>
export type StudioContentsListQueryError = unknown


export function useStudioContentsList<TData = Awaited<ReturnType<typeof studioContentsList>>, TError = unknown>(
 params: undefined |  StudioContentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioContentsList>>,
          TError,
          Awaited<ReturnType<typeof studioContentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioContentsList<TData = Awaited<ReturnType<typeof studioContentsList>>, TError = unknown>(
 params?: StudioContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioContentsList>>,
          TError,
          Awaited<ReturnType<typeof studioContentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioContentsList<TData = Awaited<ReturnType<typeof studioContentsList>>, TError = unknown>(
 params?: StudioContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStudioContentsList<TData = Awaited<ReturnType<typeof studioContentsList>>, TError = unknown>(
 params?: StudioContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStudioContentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type studioContentsCreateResponse201 = {
  data: ContentItem
  status: 201
}
    
export type studioContentsCreateResponseSuccess = (studioContentsCreateResponse201) & {
  headers: Headers;
};
;

export type studioContentsCreateResponse = (studioContentsCreateResponseSuccess)

export const getStudioContentsCreateUrl = () => {


  

  return `/api/v1/studio/contents/`
}

export const studioContentsCreate = async (contentItemRequest: ContentItemRequest, options?: RequestInit): Promise<studioContentsCreateResponse> => {
  
  return apiFetch<studioContentsCreateResponse>(getStudioContentsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contentItemRequest,)
  }
);}




export const getStudioContentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsCreate>>, TError,{data: ContentItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsCreate>>, TError,{data: ContentItemRequest}, TContext> => {

const mutationKey = ['studioContentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsCreate>>, {data: ContentItemRequest}> = (props) => {
          const {data} = props ?? {};

          return  studioContentsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsCreate>>>
    export type StudioContentsCreateMutationBody = ContentItemRequest
    export type StudioContentsCreateMutationError = unknown

    export const useStudioContentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsCreate>>, TError,{data: ContentItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsCreate>>,
        TError,
        {data: ContentItemRequest},
        TContext
      > => {

      const mutationOptions = getStudioContentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioContentsRetrieveResponse200 = {
  data: ContentItem
  status: 200
}
    
export type studioContentsRetrieveResponseSuccess = (studioContentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type studioContentsRetrieveResponse = (studioContentsRetrieveResponseSuccess)

export const getStudioContentsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/`
}

export const studioContentsRetrieve = async (id: string, options?: RequestInit): Promise<studioContentsRetrieveResponse> => {
  
  return apiFetch<studioContentsRetrieveResponse>(getStudioContentsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStudioContentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/studio/contents/${id}/`
    ] as const;
    }

    
export const getStudioContentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof studioContentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStudioContentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof studioContentsRetrieve>>> = ({ signal }) => studioContentsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof studioContentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StudioContentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof studioContentsRetrieve>>>
export type StudioContentsRetrieveQueryError = unknown


export function useStudioContentsRetrieve<TData = Awaited<ReturnType<typeof studioContentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioContentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof studioContentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioContentsRetrieve<TData = Awaited<ReturnType<typeof studioContentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioContentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof studioContentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioContentsRetrieve<TData = Awaited<ReturnType<typeof studioContentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStudioContentsRetrieve<TData = Awaited<ReturnType<typeof studioContentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStudioContentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type studioContentsPartialUpdateResponse200 = {
  data: ContentItem
  status: 200
}
    
export type studioContentsPartialUpdateResponseSuccess = (studioContentsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type studioContentsPartialUpdateResponse = (studioContentsPartialUpdateResponseSuccess)

export const getStudioContentsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/`
}

export const studioContentsPartialUpdate = async (id: string,
    patchedContentItemRequest: PatchedContentItemRequest, options?: RequestInit): Promise<studioContentsPartialUpdateResponse> => {
  
  return apiFetch<studioContentsPartialUpdateResponse>(getStudioContentsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedContentItemRequest,)
  }
);}




export const getStudioContentsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsPartialUpdate>>, TError,{id: string;data: PatchedContentItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsPartialUpdate>>, TError,{id: string;data: PatchedContentItemRequest}, TContext> => {

const mutationKey = ['studioContentsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsPartialUpdate>>, {id: string;data: PatchedContentItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  studioContentsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsPartialUpdate>>>
    export type StudioContentsPartialUpdateMutationBody = PatchedContentItemRequest
    export type StudioContentsPartialUpdateMutationError = unknown

    export const useStudioContentsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsPartialUpdate>>, TError,{id: string;data: PatchedContentItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsPartialUpdate>>,
        TError,
        {id: string;data: PatchedContentItemRequest},
        TContext
      > => {

      const mutationOptions = getStudioContentsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioContentsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type studioContentsDestroyResponseSuccess = (studioContentsDestroyResponse204) & {
  headers: Headers;
};
;

export type studioContentsDestroyResponse = (studioContentsDestroyResponseSuccess)

export const getStudioContentsDestroyUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/`
}

export const studioContentsDestroy = async (id: string, options?: RequestInit): Promise<studioContentsDestroyResponse> => {
  
  return apiFetch<studioContentsDestroyResponse>(getStudioContentsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getStudioContentsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['studioContentsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  studioContentsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsDestroy>>>
    
    export type StudioContentsDestroyMutationError = unknown

    export const useStudioContentsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStudioContentsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioContentsMarkPublishedCreateResponse200 = {
  data: ContentItem
  status: 200
}
    
export type studioContentsMarkPublishedCreateResponseSuccess = (studioContentsMarkPublishedCreateResponse200) & {
  headers: Headers;
};
;

export type studioContentsMarkPublishedCreateResponse = (studioContentsMarkPublishedCreateResponseSuccess)

export const getStudioContentsMarkPublishedCreateUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/mark_published/`
}

export const studioContentsMarkPublishedCreate = async (id: string, options?: RequestInit): Promise<studioContentsMarkPublishedCreateResponse> => {
  
  return apiFetch<studioContentsMarkPublishedCreateResponse>(getStudioContentsMarkPublishedCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getStudioContentsMarkPublishedCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsMarkPublishedCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsMarkPublishedCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['studioContentsMarkPublishedCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsMarkPublishedCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  studioContentsMarkPublishedCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsMarkPublishedCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsMarkPublishedCreate>>>
    
    export type StudioContentsMarkPublishedCreateMutationError = unknown

    export const useStudioContentsMarkPublishedCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsMarkPublishedCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsMarkPublishedCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStudioContentsMarkPublishedCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioContentsRenderVideoCreateResponse202 = {
  data: ContentItem
  status: 202
}
    
export type studioContentsRenderVideoCreateResponseSuccess = (studioContentsRenderVideoCreateResponse202) & {
  headers: Headers;
};
;

export type studioContentsRenderVideoCreateResponse = (studioContentsRenderVideoCreateResponseSuccess)

export const getStudioContentsRenderVideoCreateUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/render_video/`
}

export const studioContentsRenderVideoCreate = async (id: string, options?: RequestInit): Promise<studioContentsRenderVideoCreateResponse> => {
  
  return apiFetch<studioContentsRenderVideoCreateResponse>(getStudioContentsRenderVideoCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getStudioContentsRenderVideoCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsRenderVideoCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsRenderVideoCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['studioContentsRenderVideoCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsRenderVideoCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  studioContentsRenderVideoCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsRenderVideoCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsRenderVideoCreate>>>
    
    export type StudioContentsRenderVideoCreateMutationError = unknown

    export const useStudioContentsRenderVideoCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsRenderVideoCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsRenderVideoCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStudioContentsRenderVideoCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioContentsRenderVisualCreateResponse202 = {
  data: ContentItem
  status: 202
}
    
export type studioContentsRenderVisualCreateResponseSuccess = (studioContentsRenderVisualCreateResponse202) & {
  headers: Headers;
};
;

export type studioContentsRenderVisualCreateResponse = (studioContentsRenderVisualCreateResponseSuccess)

export const getStudioContentsRenderVisualCreateUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/render_visual/`
}

export const studioContentsRenderVisualCreate = async (id: string, options?: RequestInit): Promise<studioContentsRenderVisualCreateResponse> => {
  
  return apiFetch<studioContentsRenderVisualCreateResponse>(getStudioContentsRenderVisualCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getStudioContentsRenderVisualCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsRenderVisualCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsRenderVisualCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['studioContentsRenderVisualCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsRenderVisualCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  studioContentsRenderVisualCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsRenderVisualCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsRenderVisualCreate>>>
    
    export type StudioContentsRenderVisualCreateMutationError = unknown

    export const useStudioContentsRenderVisualCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsRenderVisualCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsRenderVisualCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStudioContentsRenderVisualCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioContentsScheduleCreateResponse200 = {
  data: ContentItem
  status: 200
}
    
export type studioContentsScheduleCreateResponseSuccess = (studioContentsScheduleCreateResponse200) & {
  headers: Headers;
};
;

export type studioContentsScheduleCreateResponse = (studioContentsScheduleCreateResponseSuccess)

export const getStudioContentsScheduleCreateUrl = (id: string,) => {


  

  return `/api/v1/studio/contents/${id}/schedule/`
}

export const studioContentsScheduleCreate = async (id: string,
    scheduleRequest: ScheduleRequest, options?: RequestInit): Promise<studioContentsScheduleCreateResponse> => {
  
  return apiFetch<studioContentsScheduleCreateResponse>(getStudioContentsScheduleCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scheduleRequest,)
  }
);}




export const getStudioContentsScheduleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsScheduleCreate>>, TError,{id: string;data: ScheduleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsScheduleCreate>>, TError,{id: string;data: ScheduleRequest}, TContext> => {

const mutationKey = ['studioContentsScheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsScheduleCreate>>, {id: string;data: ScheduleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  studioContentsScheduleCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsScheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsScheduleCreate>>>
    export type StudioContentsScheduleCreateMutationBody = ScheduleRequest
    export type StudioContentsScheduleCreateMutationError = unknown

    export const useStudioContentsScheduleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsScheduleCreate>>, TError,{id: string;data: ScheduleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsScheduleCreate>>,
        TError,
        {id: string;data: ScheduleRequest},
        TContext
      > => {

      const mutationOptions = getStudioContentsScheduleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Posts planned (or published) in [start, end), for the editorial calendar.
 */
export type studioContentsCalendarListResponse200 = {
  data: ContentItem[]
  status: 200
}
    
export type studioContentsCalendarListResponseSuccess = (studioContentsCalendarListResponse200) & {
  headers: Headers;
};
;

export type studioContentsCalendarListResponse = (studioContentsCalendarListResponseSuccess)

export const getStudioContentsCalendarListUrl = (params: StudioContentsCalendarListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/studio/contents/calendar/?${stringifiedParams}` : `/api/v1/studio/contents/calendar/`
}

export const studioContentsCalendarList = async (params: StudioContentsCalendarListParams, options?: RequestInit): Promise<studioContentsCalendarListResponse> => {
  
  return apiFetch<studioContentsCalendarListResponse>(getStudioContentsCalendarListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStudioContentsCalendarListQueryKey = (params?: StudioContentsCalendarListParams,) => {
    return [
    `/api/v1/studio/contents/calendar/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStudioContentsCalendarListQueryOptions = <TData = Awaited<ReturnType<typeof studioContentsCalendarList>>, TError = unknown>(params: StudioContentsCalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsCalendarList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStudioContentsCalendarListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof studioContentsCalendarList>>> = ({ signal }) => studioContentsCalendarList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof studioContentsCalendarList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StudioContentsCalendarListQueryResult = NonNullable<Awaited<ReturnType<typeof studioContentsCalendarList>>>
export type StudioContentsCalendarListQueryError = unknown


export function useStudioContentsCalendarList<TData = Awaited<ReturnType<typeof studioContentsCalendarList>>, TError = unknown>(
 params: StudioContentsCalendarListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsCalendarList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioContentsCalendarList>>,
          TError,
          Awaited<ReturnType<typeof studioContentsCalendarList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioContentsCalendarList<TData = Awaited<ReturnType<typeof studioContentsCalendarList>>, TError = unknown>(
 params: StudioContentsCalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsCalendarList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioContentsCalendarList>>,
          TError,
          Awaited<ReturnType<typeof studioContentsCalendarList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioContentsCalendarList<TData = Awaited<ReturnType<typeof studioContentsCalendarList>>, TError = unknown>(
 params: StudioContentsCalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsCalendarList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStudioContentsCalendarList<TData = Awaited<ReturnType<typeof studioContentsCalendarList>>, TError = unknown>(
 params: StudioContentsCalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioContentsCalendarList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStudioContentsCalendarListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 10 post ideas from the prospects' frequent questions (AI « lite », else keywords).
 */
export type studioContentsIdeasCreateResponse202 = {
  data: IdeasQueued
  status: 202
}
    
export type studioContentsIdeasCreateResponseSuccess = (studioContentsIdeasCreateResponse202) & {
  headers: Headers;
};
;

export type studioContentsIdeasCreateResponse = (studioContentsIdeasCreateResponseSuccess)

export const getStudioContentsIdeasCreateUrl = () => {


  

  return `/api/v1/studio/contents/ideas/`
}

export const studioContentsIdeasCreate = async (ideasRequestRequest: IdeasRequestRequest, options?: RequestInit): Promise<studioContentsIdeasCreateResponse> => {
  
  return apiFetch<studioContentsIdeasCreateResponse>(getStudioContentsIdeasCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ideasRequestRequest,)
  }
);}




export const getStudioContentsIdeasCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsIdeasCreate>>, TError,{data: IdeasRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioContentsIdeasCreate>>, TError,{data: IdeasRequestRequest}, TContext> => {

const mutationKey = ['studioContentsIdeasCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioContentsIdeasCreate>>, {data: IdeasRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  studioContentsIdeasCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioContentsIdeasCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioContentsIdeasCreate>>>
    export type StudioContentsIdeasCreateMutationBody = IdeasRequestRequest
    export type StudioContentsIdeasCreateMutationError = unknown

    export const useStudioContentsIdeasCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioContentsIdeasCreate>>, TError,{data: IdeasRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioContentsIdeasCreate>>,
        TError,
        {data: IdeasRequestRequest},
        TContext
      > => {

      const mutationOptions = getStudioContentsIdeasCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioIdeasListResponse200 = {
  data: PaginatedContentIdeaList
  status: 200
}
    
export type studioIdeasListResponseSuccess = (studioIdeasListResponse200) & {
  headers: Headers;
};
;

export type studioIdeasListResponse = (studioIdeasListResponseSuccess)

export const getStudioIdeasListUrl = (params?: StudioIdeasListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/studio/ideas/?${stringifiedParams}` : `/api/v1/studio/ideas/`
}

export const studioIdeasList = async (params?: StudioIdeasListParams, options?: RequestInit): Promise<studioIdeasListResponse> => {
  
  return apiFetch<studioIdeasListResponse>(getStudioIdeasListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStudioIdeasListQueryKey = (params?: StudioIdeasListParams,) => {
    return [
    `/api/v1/studio/ideas/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStudioIdeasListQueryOptions = <TData = Awaited<ReturnType<typeof studioIdeasList>>, TError = unknown>(params?: StudioIdeasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStudioIdeasListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof studioIdeasList>>> = ({ signal }) => studioIdeasList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof studioIdeasList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StudioIdeasListQueryResult = NonNullable<Awaited<ReturnType<typeof studioIdeasList>>>
export type StudioIdeasListQueryError = unknown


export function useStudioIdeasList<TData = Awaited<ReturnType<typeof studioIdeasList>>, TError = unknown>(
 params: undefined |  StudioIdeasListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioIdeasList>>,
          TError,
          Awaited<ReturnType<typeof studioIdeasList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioIdeasList<TData = Awaited<ReturnType<typeof studioIdeasList>>, TError = unknown>(
 params?: StudioIdeasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioIdeasList>>,
          TError,
          Awaited<ReturnType<typeof studioIdeasList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioIdeasList<TData = Awaited<ReturnType<typeof studioIdeasList>>, TError = unknown>(
 params?: StudioIdeasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStudioIdeasList<TData = Awaited<ReturnType<typeof studioIdeasList>>, TError = unknown>(
 params?: StudioIdeasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStudioIdeasListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type studioIdeasRetrieveResponse200 = {
  data: ContentIdea
  status: 200
}
    
export type studioIdeasRetrieveResponseSuccess = (studioIdeasRetrieveResponse200) & {
  headers: Headers;
};
;

export type studioIdeasRetrieveResponse = (studioIdeasRetrieveResponseSuccess)

export const getStudioIdeasRetrieveUrl = (id: string,) => {


  

  return `/api/v1/studio/ideas/${id}/`
}

export const studioIdeasRetrieve = async (id: string, options?: RequestInit): Promise<studioIdeasRetrieveResponse> => {
  
  return apiFetch<studioIdeasRetrieveResponse>(getStudioIdeasRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStudioIdeasRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/studio/ideas/${id}/`
    ] as const;
    }

    
export const getStudioIdeasRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStudioIdeasRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof studioIdeasRetrieve>>> = ({ signal }) => studioIdeasRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StudioIdeasRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof studioIdeasRetrieve>>>
export type StudioIdeasRetrieveQueryError = unknown


export function useStudioIdeasRetrieve<TData = Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioIdeasRetrieve>>,
          TError,
          Awaited<ReturnType<typeof studioIdeasRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioIdeasRetrieve<TData = Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studioIdeasRetrieve>>,
          TError,
          Awaited<ReturnType<typeof studioIdeasRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStudioIdeasRetrieve<TData = Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStudioIdeasRetrieve<TData = Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof studioIdeasRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStudioIdeasRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type studioIdeasAcceptCreateResponse201 = {
  data: ContentItem
  status: 201
}
    
export type studioIdeasAcceptCreateResponseSuccess = (studioIdeasAcceptCreateResponse201) & {
  headers: Headers;
};
;

export type studioIdeasAcceptCreateResponse = (studioIdeasAcceptCreateResponseSuccess)

export const getStudioIdeasAcceptCreateUrl = (id: string,) => {


  

  return `/api/v1/studio/ideas/${id}/accept/`
}

export const studioIdeasAcceptCreate = async (id: string, options?: RequestInit): Promise<studioIdeasAcceptCreateResponse> => {
  
  return apiFetch<studioIdeasAcceptCreateResponse>(getStudioIdeasAcceptCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getStudioIdeasAcceptCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioIdeasAcceptCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioIdeasAcceptCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['studioIdeasAcceptCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioIdeasAcceptCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  studioIdeasAcceptCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioIdeasAcceptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioIdeasAcceptCreate>>>
    
    export type StudioIdeasAcceptCreateMutationError = unknown

    export const useStudioIdeasAcceptCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioIdeasAcceptCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioIdeasAcceptCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStudioIdeasAcceptCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type studioIdeasDismissCreateResponse200 = {
  data: ContentIdea
  status: 200
}
    
export type studioIdeasDismissCreateResponseSuccess = (studioIdeasDismissCreateResponse200) & {
  headers: Headers;
};
;

export type studioIdeasDismissCreateResponse = (studioIdeasDismissCreateResponseSuccess)

export const getStudioIdeasDismissCreateUrl = (id: string,) => {


  

  return `/api/v1/studio/ideas/${id}/dismiss/`
}

export const studioIdeasDismissCreate = async (id: string, options?: RequestInit): Promise<studioIdeasDismissCreateResponse> => {
  
  return apiFetch<studioIdeasDismissCreateResponse>(getStudioIdeasDismissCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getStudioIdeasDismissCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioIdeasDismissCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studioIdeasDismissCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['studioIdeasDismissCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studioIdeasDismissCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  studioIdeasDismissCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StudioIdeasDismissCreateMutationResult = NonNullable<Awaited<ReturnType<typeof studioIdeasDismissCreate>>>
    
    export type StudioIdeasDismissCreateMutationError = unknown

    export const useStudioIdeasDismissCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studioIdeasDismissCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof studioIdeasDismissCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStudioIdeasDismissCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    